'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getIndexesForPage = function (itemsPerPage, page) {
    if (itemsPerPage === void 0) { itemsPerPage = 1; }
    if (page === void 0) { page = 1; }
    var stop = page > 0 ? page * itemsPerPage : itemsPerPage;
    var start = stop - itemsPerPage;
    return { start: start, stop: stop };
};
var clientSideListStrategy = {
    getIndexesForPage: getIndexesForPage
};

exports.default = clientSideListStrategy;
exports.getIndexesForPage = getIndexesForPage;
//# sourceMappingURL=clientSideListStrategy.js.map
